<template>
  <div class="header">
    <div class="clearfix container" style="position: relative">
      <ul class="l nav-menu">
        <li><h1><a href="/"><img src="../assets/images/logo.png" style="width: 111px;"/></a></h1></li>
        <li><a href="/">首页</a></li>
        <li><a href="valuer.html" target="_blank">拍片估价</a></li>
        <li><a href="case.html">案例展示</a></li>
        <li><a href="talent.html">行业资源</a></li>
        <!--<li><a href="activity.html">活动中心</a></li>-->
        <li><a href="newsList.html">新闻资讯</a></li>
        <li><a href="about.html">关于我们</a></li>
      </ul>
      <ul class="r nav-user-operate">
        <li><a class="create-video" @click="goPublish"><i class="icon xj"></i>我要拍片</a></li>
        <li v-if="noUser"><a href="register.html" class="login">登录</a>|<a href="register.html" class="register">注册</a></li>
        <li v-if="!noUser && Object.keys(userInfos).length > 0" class="userName" @mouseover="overShow" style="positive: relative;">
          <!--<img v-if="Object.keys(userInfos).length > 0" style="width:40px;height: 40px;border-radius: 50%;margin-top: 10px;" :src="userInfos.data.faceUrl ? userInfos.data.faceUrl:defaultUrl" alt="">-->
          <img style="width:40px;height: 40px;border-radius: 50%;" :src="userInfos.data.faceUrl ? userInfos.data.faceUrl:defaultUrl" alt="">
          <span v-show="userInfos.hasMsg == 1" style="width:5px;height:5px;border-radius:5px;background-color:red;display: block;position: absolute;right: 5px;top: 13px;"></span>
        </li>
      </ul>
      <div  @mouseleave="outHide"  class="person-index" :class="{'person-show':personIndex === true}" style="width: 180px;height: auto;"  v-if="!noUser && Object.keys(userInfos).length > 0" >
        <ul>
          <!-- <li style=""><a href="javascript:;">{{userInfos ? userInfos.data.nickName:''}}</a></li> -->
          <li style="positive: relative;">
            <a href="inform.html">消息</a>
            <span v-show="userInfos.hasMsg == 1" style="width:5px;height:5px;border-radius:5px;background-color:red;display: block;position: absolute;right: 20px;top: 20px;"></span>
          </li>
          <li v-if="userInfos.data.producerType != 3"><a :href="'userPage.html?id='+userInfos.data.id+'&origin=1'" target="_blank">制作人中心</a></li>
          <li v-if="userInfos.data.producerType == 3"><a :href="'talentActor.html?id='+userInfos.data.id+'&origin=1'" target="_blank">制作人中心</a></li>
          <li><a href="project.html">我的项目</a></li>
          <li><a href="collectionList.html">我的收藏</a></li>
          <li v-if="userInfos.data.isProducer === 1"><a href="person.html">钱包</a></li>
          <li><a href="account.html">账号设置</a></li>
          <li @click="logout()"><a href="javascript:;">退出登录</a></li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { apiReg, accountApi } from "../fetch/api";
import img1 from "../assets/images/icon_wdy.png";
export default {
  props: {},
  data() {
    return {
      personIndex: false,
      noUser: "",
      userInfos: {},
      userInfoName: "111",
      defaultUrl: img1
    };
  },
  methods: {
    goPublish() {
      location.href = "publish.html";
    },
    overShow() {
      this.personIndex = true;
    },
    outHide() {
      this.personIndex = false;
    },
    logout() {
      apiReg.apiLogout().then(data => {
        this.personIndex = false;
        localStorage.removeItem("userInfo");
        this.noUser = true;
        window.location.href = "index.html";
      });
    },
    getDetail() {
      accountApi.apiAccountGetDetail().then(data => {
        this.userInfos = data;
        if (data.status === -1 || data.status == 0) {
          this.noUser = true;
          localStorage.removeItem("userInfo");
        } else {
          this.noUser = false;
          if(data.isSignOff == 1){
            this.logout();
          }
        }
      });
    }
  },
  mounted() {},
  created() {
    if (JSON.parse(localStorage.getItem("userInfo"))) {
      //已登录
      // this.getDetail();
      this.userInfos = JSON.parse(localStorage.getItem("userInfo"));
      this.getDetail();

      this.noUser = false;
    } else {
      //未登录
      this.noUser = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  padding: 0 30px;
  width: 100%;
  font-size: 16px;
  z-index: 9999;
  transition: ease 0.5s all;
}
.nav-menu {
  height: 60px;
  line-height: 60px;
}
.nav-menu li {
  float: left;
  padding: 0 20px;
}
.nav-menu li:first-child {
  padding-left: 0;
}
.nav-menu li h1 {
  margin: 17px 0 0;
  height: 26px;
  line-height: 26px;
  font-size: 22px;
}
.nav-menu li a{
  color: #FFFFFF;
}
.login,.register{
  color: #ffffff;
}
.nav-user-operate {
  height: 60px;
  line-height: 60px;
}
.nav-user-operate li {
  float: left;
  padding: 0 10px;
}
.nav-user-operate li:last-child {
  padding-right: 0;
}
.nav-user-operate li .create-video {
  display: inline-block;
  width: 140px;
  height: 36px;
  line-height: 34px;
  color: #ffffff;
  text-align: center;
  background-color: #3e87ff;
  border: 1px solid #3e87ff;
  border-radius: 100px;
}
.nav-user-operate li .login,
.nav-user-operate li .register {
  padding: 0 14px;
  height: 60px;
  line-height: 60px;
}
.nav-user-operate li a i.xj {
  margin-top: -3px;
  margin-right: 10px;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  background: url("../assets/images/image.png") no-repeat;
  background-position: -753px -973px;
}
.nav-user-operate li .create-video:hover {
  opacity: 0.8;
}
.person-index {
  display: none;
  position: absolute;
  right: 0;
  top: 60px;
  width: 120px;
  height: auto;
  background: #fff;
  text-align: center;
}
.person-index li {
  border-bottom: 1px solid #f3f4f5;
  cursor: pointer;
  text-align: left;
  padding-left: 40px;
  height: 50px;
  border: none;
}
.person-index li a {
  display: block;
  width: 100%;
  height: 50px;
  line-height: 100%;
  padding: 10px 0;
  font-size: 14px;
  color: #424753;
  line-height: 25px;
}
/* .person-index li:first-child a{
    color: #5C8DDE;
  }
  .person-index li:last-child{
    border-bottom: none;
    color: #424753;
    opacity: 0.4;
  } */
.person-index li:hover {
  background: #3e87ff;
  color: #fff;
}
.person-index li a:hover {
  color: #fff !important;
}
.person-show {
  display: block;
}
</style>



// WEBPACK FOOTER //
// Header.vue?1ee0b962